import { ThemeProvider } from "styled-components";
import { portfolio } from "./components/Themes";
import GlobalStyle from "./globalStyles";

import Navbar from "./components/portfolio/Navbar";
import Hero from "./components/portfolio/Hero";
import About from "./components/portfolio/About";
import Experience from "./components/portfolio/Experience";
import Skills from "./components/portfolio/Skills";
import Projects from "./components/portfolio/Projects";
import Contact from "./components/portfolio/Contact";

function App() {
  return (
    <ThemeProvider theme={portfolio}>
      <GlobalStyle />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Projects />
        <Contact />
      </main>
    </ThemeProvider>
  );
}

export default App;
